const services = [
  {
    icon: "ri-time-line",
    title: "Emergency Passport",
    description: "Offshore rotation to West Africa in ten days? Business trip to Paris for a festival partnership? Our emergency courier service prioritizes your application and submits directly via reserved agency slots — as fast as 24 hours.",
    bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
    badge: "Same-Day Available",
    link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
  },
  {
    icon: "ri-refresh-line",
    title: "Passport Renewal",
    description: "Already hold a U.S. passport? We help Lafayette residents renew fast — no agency visit required for most renewals. Perfect for oil & gas engineers, ULL faculty, and Acadiana families preparing for international travel.",
    bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
    badge: "Most Common",
    link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
  },
  {
    icon: "ri-file-add-line",
    title: "New Passport",
    description: "First-time applicants typically require an in-person acceptance clerk visit. We guide you through every step, from downtown Lafayette to the clerk's office, with clear instructions for Acadiana residents.",
    bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
    badge: null,
    link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
  },
  {
    icon: "ri-search-eye-line",
    title: "Lost or Stolen Passport",
    description: "Replacements often require additional forms. We guide you through exactly what is needed to avoid costly mistakes and delays, so your offshore assignment or European vacation is not derailed.",
    bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
    badge: null,
    link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
  },
  {
    icon: "ri-parent-line",
    title: "Child Passport",
    description: "Minors (15 and under) require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your family vacation or cultural exchange program stays on schedule.",
    bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
    badge: null,
    link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
  },
  {
    icon: "ri-edit-line",
    title: "Name Change",
    description: "After marriage, divorce, or a legal name change — we assist with corrected passports and data corrections so your travel documents match your reservations and professional credentials.",
    bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
    badge: null,
    link: "https://fastpassportcenter.com/checkout/?passport=name-change",
  },
  {
    icon: "ri-book-2-line",
    title: "Second Passport",
    description: "Need a second passport for frequent international travel? We handle second passport issuance efficiently — ideal for offshore engineers, consultants, and hospitality professionals who cross borders regularly.",
    bullets: ["Frequent traveler solutions", "Valid alongside existing passport", "Expedited processing"],
    badge: null,
    link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
  },
  {
    icon: "ri-error-warning-line",
    title: "Damaged Passport",
    description: "Replacing a significantly damaged or water-damaged passport? We guide Lafayette travelers through the replacement process with clear instructions.",
    bullets: ["Damaged passport replacement", "Documentation guidance", "Expedited processing"],
    badge: null,
    link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
  },
  {
    icon: "ri-bank-card-line",
    title: "Passport Card",
    description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
    bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
    badge: null,
    link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
  },
];

export default function LafayetteServicesSection() {
  return (
    <section id="services" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Our Services</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Services We Expedite for Lafayette Travelers
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Whether you need a renewal before an offshore rotation to West Africa, a first-time passport for a European heritage tour, or an emergency replacement before a business trip — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30&ndash;100% less than FedEx, Staples, and other third-party passport courier resellers.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, i) => (
            <div
              key={i}
              className="group relative bg-white border border-gray-200 rounded-lg p-6 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
            >
              {service.badge && (
                <span className="absolute top-4 right-4 bg-[#1A365D] text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                  {service.badge}
                </span>
              )}
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EEF2F8] mb-4">
                <i className={`${service.icon} text-[#1A365D] text-xl`}></i>
              </div>
              <h3 className="font-bold text-[#1A365D] text-sm mb-2">{service.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">{service.description}</p>
              <ul className="space-y-1.5 mb-6 flex-1">
                {service.bullets.map((b, j) => (
                  <li key={j} className="flex items-center gap-2 text-sm text-gray-600">
                    <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                    {b}
                  </li>
                ))}
              </ul>
              <a
                href={service.link}
                className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-sm hover:text-[#F6C344] transition-colors mt-auto whitespace-nowrap"
              >
                Get Started <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}